export const hasRequiredFeatures = window => {
  const {
    requestAnimationFrame,
    WeakMap,
    URLSearchParams,
    Promise: {
      all
    } = {
      all: undefined
    },
    Promise: {
      resolve
    } = {
      resolve: undefined
    }
  } = window;
  return [requestAnimationFrame, WeakMap, URLSearchParams, all, resolve].every(value => typeof value === 'function');
};